import { AiActionTypes } from '../actions/aiActions';
import { RootActions } from '../redux';
import { aiState, AiState } from '../states/aiState';

const aiReducer = (state = aiState, action: RootActions): AiState => {
  switch (action.type) {
    case AiActionTypes.TOGGLE_AI:
      return {
        ...state,
        aiVisible: action.payload,
      };

    case AiActionTypes.GET_CONVERSATION_LIST: {
      // Add opening curly brace here
      const newConversationsToAdd = Array.isArray(action.payload) ? action.payload : [action.payload];
      return {
        ...state,
        conversationList: [...state.conversationList, ...newConversationsToAdd],
      };
    } // Add closing curly brace here
    default:
      return state;
  }
};

export default aiReducer;
